import { render, staticRenderFns } from "./OnBehalfOf.vue?vue&type=template&id=369f404a&scoped=true&"
import script from "./OnBehalfOf.vue?vue&type=script&lang=js&"
export * from "./OnBehalfOf.vue?vue&type=script&lang=js&"
import style0 from "./OnBehalfOf.vue?vue&type=style&index=0&id=369f404a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369f404a",
  null
  
)

export default component.exports